<template>
<div class="MOrder">
    <van-tabs v-model="param.status" animated color="#409EFF" title-active-color="#409EFF" title-inactive-colo="#666666" sticky>
        <van-tab title="全部">
            <MOrderListAll></MOrderListAll>
        </van-tab>
        <van-tab title="待支付">
            <MOrderListPaying></MOrderListPaying>
        </van-tab>
        <van-tab title="已完成">
            <MOrderListSuccess></MOrderListSuccess>
        </van-tab>
        <van-tab title="已取消">
            <MOrderListFail></MOrderListFail>
        </van-tab>
    </van-tabs>
</div>
</template>

<script>
import MOrderListAll from 'views/mobile/my/order/components/mOrderListAll'
import MOrderListPaying from 'views/mobile/my/order/components/mOrderListPaying'
import MOrderListSuccess from 'views/mobile/my/order/components/mOrderListSuccess'
import MOrderListFail from 'views/mobile/my/order/components/mOrderListFail'
import {mapActions} from 'vuex'
export default {
    name: 'MOrder',
    data() {
        return {
            param: {
                status: ''
            }
        }
    },
    mounted() {
        this.setNoDataTip('当前还没有订单，快去参与学习吧！')
        document.title = '我的订单'
    },
    methods: {
        ...mapActions(['setNoDataTip'])
    },
    filters: {},
    watch: {},
    computed: {},
    components: {
        MOrderListAll, MOrderListSuccess, MOrderListFail, MOrderListPaying
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
@import "~common/scss/variable";
.MOrder {
    .van-tabs__content {
        background: #F5F7FA;
    }
    .van-tab__pane{
        height: calc(100vh - 0.88rem);
        overflow: scroll;
    }
    .noData{
        height:calc(100vh - 0.88rem);
        background: $c-white;
    }
    .van-tabs__line{
        height: 0.04rem;
    }
}
</style>